// Values for all variables here should match with values in _variables.scss.

export const baseColors = {
  // novisci official colors
  gunMetal: 'rgb(43, 50, 64)',
  oriolesOrange: 'rgb(236, 88, 51)',
  metallicSeaweed: 'rgb(54, 126, 142)',
  midnightGreen: 'rgb(35, 74, 93)',
  nyanza: 'rgb(234, 252, 227)',
  fulvous: 'rgb(213, 136, 52)',

  // gray hues
  gray: 'rgb(140, 140, 140)',
  silver: 'rgb(204, 204, 204)',
  concrete: 'rgb(242, 242, 242)',
  whiteSmoke: 'rgb(249, 249, 249)'
}

export const colors = Object.assign(baseColors, {
  cardBackground: 'white',
  textGray: baseColors.gray,
  borderGray: baseColors.silver,
  backgroundGray: baseColors.whiteSmoke,
  tableRowStripedBackground: baseColors.concrete,
  error: 'rgb(221, 90, 61)',
  info: 'rgb(9, 178, 231)',
  success: 'rgb(53, 187, 123)',
  warning: 'rgb(245, 152, 52)'
})

export const sizes = {
  pageHeaderHeight: '80px',
  buttonHeight: '32px',
  textInputHeight: '42px',
  formElementPadding: '16px',
  formElementMediumPadding: '10px'
}

export const zIndexes = {
  reportEditorPageHeader: 5,
  pageControlBar: 9,
  dropdownMenuOverlay: 10,
  inputMessageTooltip: 10,
  dropdownMenu: 11,
  modalOverlay: 20,
  modal: 21,
  navbar: 40,
  editableBlockActionsArea: 3,
  blockConfirmation: 4,
  sideBySideChartLeft: 3,
  sideBySideChartRight: 2,
  sideBySideChartFilterBar: 1,
  chartLoader: 3,
  executiveSummaryFullReportLink: 19
}
